import Header from "../../components/common/Header";
import Icon from "../../components/common/Icon";
import useAuth from "../../hooks/useAuth";
import {getDocumentList} from "../../api/admin/documentReq";
import {useEffect, useState} from "react";

export default function BankInfos() {
    const sources = "fa fa-bank"
    const { auth } = useAuth();
    const token = auth.token;
    const [documents, setDocuments] = useState();
    const IMG_FOLDER = process.env.REACT_APP_API_BASE_URL;

    const apiDocuments = async () => {
        const response = await getDocumentList(token)
        setDocuments(response)
    }

    useEffect(() => {
        apiDocuments()
    }, [ token ]);


    return (
        <main>
            <Header location="Informations bancaires" parent="" />
            <div className="content-container bank-infos">
                <Icon source={sources} color="blue" span="Demande & autorisation de prélèvement"/>
                <p>
                    Depuis 2013, la réglementation bancaire n’autorise plus les autorisations de
                    prélèvements.
                    Afin de permettre les prélèvements sur votre compte bancaire,
                    vous trouverez ci-dessous le mandat SEPA à télécharger.<br/>

                    { documents?.filter(document => document?.type === 1)?.map(document => (
                        <button type="button"><a href={`${IMG_FOLDER}/documents/${document?.fileName}`}
                                   target="_blank"><i className="fa fa-download"/><span>Télécharger</span></a></button>
                    ))}

                    Merci de nous retourner celui-ci signé et accompagné de votre RIB chez :<br/>

                    Obsèques en France<br/>
                    6 Avenue Foch<br/>
                    59440 AVESNELLES.
                </p>
            </div>
        </main>
    )
}